import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AuthService from '../../../services/AuthService';
import { useAppDispatch } from '../../../store';
import { addRedirectUrl } from '../../../store/common';

const RedirectParams: FC = ({ children }) => {
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!AuthService.hasAuthInStorage()) {
      dispatch(addRedirectUrl({ pathname, search }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
};

export default RedirectParams;
